import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectResendEmailConfirmation = createDeepEqualSelector(
  selectAuth,
  (auth) => auth.resendEmailConfirmation,
);
